<template>
  <div class='BtnImgs'>
    <button @click="Select"
    :style="{
      backgroundColor: Prefes.btn.corBackground,
      color: Prefes.btn.corFont,
      fontFamily: Prefes.btn.font,
      ...style
    }"
    >
      Ver Fotos
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'BtnImgs',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    style: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/site/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    }
  }
}
</script>

<style scoped>
.BtnImgs {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  margin-bottom: 8px;
}

button {
  border: 0;
  background-color: orange;
  padding: 2%;
  border-radius: 8px;
  cursor: pointer;
}
</style>
